import { log } from './log';

export function resolveEventType()
{
    log('info', 'lifecycle::resolveEventType');

    return null;
}
